import React from "react";
import { createLogger } from "debug/DebugingLogger";
import { PaddleFrameDialog } from "components/main/organizations/PaddleFrameDialog";
import { openCheckout, type CheckoutRequest } from "@/lib/paddle";

const log = createLogger("CheckoutDialog");

export const CheckoutDialog: React.FC<{
  /// `null` when nothing is being bought; a new object opens a new checkout.
  request: CheckoutRequest | null;
  /// For the title.
  planName: string;
  onClose: () => void;
  /// The reveal wait is over, however it ended.
  onSettled: () => void;
}> = ({ request, planName, onClose, onSettled }) => (
  <PaddleFrameDialog
    openKey={request}
    title={planName ? `Upgrade to ${planName}` : "Checkout"}
    failureText="Checkout could not be opened. Close this and try again."
    onClose={onClose}
    onSettled={onSettled}
    openFrame={(settle) =>
      request === null
        ? Promise.resolve()
        : openCheckout({ ...request, onLoaded: settle })
    }
    onOpenFailed={(e) => log.error("checkout failed to open", e)}
  />
);
